<template>
  <div>
    <!-- <p>房费原价：{{payInfo.totalRoomPrice | toPrice}}元 &nbsp; 
      总应结房费：{{payInfo.totalRealPrice | toPrice}}元 &nbsp; 
      累积已日结：{{payInfo.totalDailyPrice | toPrice}}元
    </p><br> -->
    <Table stripe :columns="columns" :data="payInfo.consumptionList"></Table>
  </div>
</template>

<script>
export default {
  props: {
    payInfo: {
      type: Object,
      default () {
        return {
          item: ''
        }
      }
    }
  },
  data() {
    return {
      columns: [
        {
          title: '房费原价',
          align: 'center',
          width: 150,
          render: (h, param) => {
            return h('div', {}, `¥${(param.row.price/100).toFixed(2)}`)
          }
        },
        {
          title: '业主优惠',
          align: 'center',
          width: 150,
          render: (h, param) => {
            return h('div', {}, `¥${(param.row.ownerBear/100).toFixed(2)}`)
          }
        },
        {
          title: 'xbed优惠',
          align: 'center',
          width: 150,
          render: (h, param) => {
            return h('div', {}, `¥${(param.row.xbedBear/100).toFixed(2)}`)
          }
        },
        {
          title: '渠道费',
          align: 'center',
          width: 150,
          key: 'channelPrice',
          render: (h, param) => {
            return h('div', {}, `¥${(param.row.channelPrice/100).toFixed(2)}`)
          }
        },
        {
          title: '用户应付',
          align: 'center',
          width: 150,
          render: (h, param) => {
            return h('div', {}, `¥${(param.row.userShouldPay/100).toFixed(2)}`)
          }
        },
        {
          title: '房费日期',
          align: 'center',
          width: 150,
          key: 'curDate'
        },
        {
          title: '操作时间',
          align: 'center',
          width: 150,
          key: 'updatedAt'
        },
        {
          title: '状态',
          align: 'center',
          width: 150,
          render: (h,param) => {
            return h('div', {}, ["","未日结","已日结","取消"][param.row.stat])
          }
        },
        {
          title: '备注',
          align: 'center',
          width: 150,
          key: 'remark'
        },
      ]
    }
  },
  filters: {
    toPrice(price) {
      if (isNaN(price)) {
        return '¥ 0.00';
      }
      return '¥ '+(price/100).toFixed(2);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/order/order_detail/pay-by-day.vue